document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".js-change-project");
  if (!items.length) return;

  const wrapper = document.querySelector(".js-projects-wrapper");

  const leftSplide = new Splide(".js-splide-left", {
    type: "fade",
    rewind: true,
    arrows: false,
    pagination: false,
    speed: 400,
    drag: false
  });

  const rightSplide = new Splide(".js-splide-right", {
    type: "fade",
    rewind: true,
    arrows: false,
    pagination: false,
    speed: 400,
    drag: false
  });

  leftSplide.sync(rightSplide);
  leftSplide.mount();
  rightSplide.mount();

  const isMobile = window.matchMedia("(max-width: 991px)").matches;

  function showWrapper() {
    wrapper.classList.add("active-projects");
  }

  function hideWrapper() {
    wrapper.classList.remove("active-projects");
  }

  items.forEach((item) => {
    const index = parseInt(item.dataset.index, 10);
    if (isNaN(index)) return;

    if (!isMobile) {
      item.addEventListener("mouseenter", () => {
        leftSplide.go(index);
        showWrapper();
      });

      item.addEventListener("mouseleave", () => {
        hideWrapper();
      });
    }

    item.addEventListener("click", (e) => {
      e.preventDefault();

      items.forEach(i => i.classList.remove("active"));
      item.classList.add("active");

      leftSplide.go(index);
      showWrapper();
    });
  });

  const projectList = wrapper.querySelector(".projects-list");

  if (projectList && !isMobile) {
    projectList.addEventListener("mouseleave", () => {
      hideWrapper();
    });
  }
});